import React from 'react'
import { useNavigate } from 'react-router-dom'
import { C } from '../styles/tokens'

export default function ProductCard({ product, onAdd }) {
  const navigate = useNavigate()
  const [hov, setHov] = React.useState(false)
  const [imgIdx, setImgIdx] = React.useState(0)
  const [adding, setAdding] = React.useState(false)
  const imgs = product.imgs?.length ? product.imgs : []
  const timerRef = React.useRef(null)
  const mrp = product.mrp || Math.round((product.price || 0) * 1.3)
  const savings = product.price && mrp > product.price ? Math.round(((mrp - product.price) / mrp) * 100) : 0

  const startCycle = () => {
    if (imgs.length <= 1) return
    timerRef.current = setInterval(() => setImgIdx(i => (i + 1) % imgs.length), 1200)
  }
  const stopCycle = () => { clearInterval(timerRef.current); setImgIdx(0) }

  const handleAdd = (e) => {
    e.stopPropagation()
    onAdd(product)
    setAdding(true)
    setTimeout(() => setAdding(false), 1800)
  }

  return (
    <div
      onMouseEnter={() => { setHov(true); startCycle() }}
      onMouseLeave={() => { setHov(false); stopCycle() }}
      onClick={() => navigate(`/product/${product.id}`)}
      style={{
        background: 'white',
        borderRadius: 14,
        overflow: 'hidden',
        cursor: 'pointer',
        border: `1px solid ${hov ? C.g300 : '#eee'}`,
        boxShadow: hov ? '0 8px 28px rgba(45,107,66,.1)' : '0 1px 4px rgba(0,0,0,.05)',
        transition: 'all .25s',
        transform: hov ? 'translateY(-4px)' : 'none',
        display: 'flex',
        flexDirection: 'column',
      }}>

      {/* Image area */}
      <div style={{ position: 'relative', background: 'white', paddingTop: '100%' }}>
        <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
          {imgs.length > 0
            ? <img
                key={imgIdx}
                src={imgs[imgIdx]}
                alt={product.name}
                style={{ width: '100%', height: '100%', objectFit: 'contain', mixBlendMode: 'multiply', transition: 'transform .3s', transform: hov ? 'scale(1.07)' : 'scale(1)' }}
              />
            : <span style={{ fontSize: '3.5rem', opacity: .15 }}>{product.emoji || '🧴'}</span>
          }
        </div>

        {/* Badges */}
        {savings >= 5 && (
          <span style={{ position: 'absolute', top: 10, left: 10, background: '#e53e3e', color: 'white', fontSize: '.62rem', fontWeight: 700, padding: '3px 8px', borderRadius: 6, zIndex: 2 }}>
            {savings}% OFF
          </span>
        )}
        {product.badge && (
          <span style={{ position: 'absolute', top: savings >= 5 ? 34 : 10, left: 10, background: C.g700, color: 'white', fontSize: '.58rem', fontWeight: 600, padding: '3px 9px', borderRadius: 999, letterSpacing: '.07em', zIndex: 2 }}>
            {product.badge.toUpperCase()}
          </span>
        )}
        {product.needsImage && (
          <span style={{ position: 'absolute', top: 10, right: 10, background: '#F59E0B', color: 'white', fontSize: '.58rem', fontWeight: 700, padding: '3px 7px', borderRadius: 999, zIndex: 2 }}>
            ⚠️
          </span>
        )}

        {/* Dot indicators */}
        {hov && imgs.length > 1 && (
          <div style={{ position: 'absolute', bottom: 8, left: 0, right: 0, display: 'flex', justifyContent: 'center', gap: 4 }}>
            {imgs.slice(0, 5).map((_, i) => (
              <div key={i} onClick={e => { e.stopPropagation(); setImgIdx(i); clearInterval(timerRef.current) }}
                style={{ width: i === imgIdx ? 14 : 5, height: 5, borderRadius: 999, background: i === imgIdx ? C.g700 : 'rgba(0,0,0,.2)', transition: 'all .2s', cursor: 'pointer' }} />
            ))}
          </div>
        )}
      </div>

      {/* Info */}
      <div style={{ padding: '12px 14px 14px', flex: 1, display: 'flex', flexDirection: 'column', gap: 4, borderTop: '1px solid #f3f4f6' }}>
        <div style={{ fontSize: '.6rem', letterSpacing: '.1em', textTransform: 'uppercase', color: C.g500, fontWeight: 700 }}>{product.cat}</div>
        <div style={{ fontSize: '.85rem', fontWeight: 600, color: '#1a1a1a', lineHeight: 1.3, display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden', flex: 1 }}>
          {product.name}
        </div>

        {product.rating && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 3 }}>
            {[1,2,3,4,5].map(i => (
              <svg key={i} width="10" height="10" viewBox="0 0 24 24" fill={i <= Math.round(parseFloat(product.rating)) ? '#F59E0B' : '#E5E7EB'}>
                <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
              </svg>
            ))}
            <span style={{ fontSize: '.65rem', color: '#9CA3AF' }}>{parseFloat(product.rating).toFixed(1)}</span>
          </div>
        )}

        {/* Price row */}
        <div style={{ display: 'flex', alignItems: 'baseline', gap: 6, marginTop: 2 }}>
          <span style={{ fontFamily: "'DM Serif Display',serif", fontSize: '1.15rem', color: '#111', fontWeight: 700 }}>₹{product.price}</span>
          {mrp > product.price && <span style={{ fontSize: '.75rem', color: '#9CA3AF', textDecoration: 'line-through' }}>₹{mrp}</span>}
        </div>

        {/* Add to cart */}
        <button
          onClick={handleAdd}
          style={{
            marginTop: 8,
            width: '100%',
            padding: '.6rem',
            borderRadius: 8,
            background: adding ? C.g600 : C.g900,
            color: 'white',
            border: 'none',
            fontSize: '.78rem',
            fontWeight: 700,
            cursor: 'pointer',
            fontFamily: "'DM Sans',sans-serif",
            letterSpacing: '.04em',
            transition: 'background .2s',
          }}>
          {adding ? '✓ Added' : 'Add to Cart'}
        </button>
      </div>
    </div>
  )
}
